// Google Ads conversion tracking.
//
// The global site tag (gtag.js) is loaded in public/index.html, which also
// runs `gtag('config', ...)` for the Google Ads account. This module only
// fires the individual conversion events, using the `send_to` value of each
// event snippet provided in Google Ads.
export const GOOGLE_ADS_ID = "AW-18217005501";

export const conversions = {
  formSubmit: `${GOOGLE_ADS_ID}/j4LNCNOv1OEcEL3jxe5D`,
  emailClick: `${GOOGLE_ADS_ID}/vEMNCJjH4uEcEL3jxe5D`,
  phoneClick: `${GOOGLE_ADS_ID}/sqqaCN_u5OEcEL3jxe5D`,
};

// Sends a Google Ads conversion event.
// `callback` is invoked once the event is sent, or after a 1s timeout so a
// pending navigation (mailto:/tel:) is never blocked by the network.
export const reportConversion = (sendTo, callback) => {
  const done = typeof callback === "function" ? callback : () => {};

  if (!sendTo || typeof window.gtag !== "function") {
    done();
    return;
  }

  let fired = false;
  const fireOnce = () => {
    if (fired) return;
    fired = true;
    done();
  };

  window.setTimeout(fireOnce, 1000);
  window.gtag("event", "conversion", {
    send_to: sendTo,
    event_callback: fireOnce,
  });
};
